const Translations = {
    Actions: { english: "Actions", spanish: "Acciones", portuguese: "Ações" },
    Active: { english: "Active", spanish: "Activo", portuguese: "Ativo" },
    ActivePunchWarning: {
        english:
            "You are already punched in on a job. Click confirm to finish the old job and start the new one.",
        spanish:
            "Todos ProyectosYa estás marcado en un trabajo. Haga clic en confirmar para finalizar el trabajo anterior y comenzar el nuevo.",
        portuguese:
            "Você já está marcado para um trabalho. Clique em confirmar para finalizar o trabalho antigo e iniciar o novo.",
    },
    Add: { english: "Add", spanish: "Agregar", portuguese: "Adicionar" },
    AddCustomer: {
        english: "Add Customer",
        spanish: "Agregar Cliente",
        portuguese: "Adicionar Cliente",
    },
    AddFixture: {
        english: "Add Fixture",
        spanish: "Agregar Accesorio",
        portuguese: "Adicionar Aparelho",
    },
    AddNew: {
        english: "Add New",
        spanish: "Agregar Nuevo",
        portuguese: "Adicionar Novo",
    },
    AddProject: {
        english: "Add Project",
        spanish: "Agregar Proyecto",
        portuguese: "Adicionar Projeto",
    },
    AddUser: {
        english: "Add User",
        spanish: "Agregar Usuario",
        portuguese: "Adicionar Usuário",
    },
    All: { english: "All", spanish: "Todo", portuguese: "Todos" },
    AllEmployees: {
        english: "All Employees",
        spanish: "Todos Empleados",
        portuguese: "Todos Funcionário",
    },
    AllProjects: {
        english: "All Projects",
        spanish: "Todos Proyectos",
        portuguese: "Todos Projetos",
    },
    Area: { english: "Area", spanish: "Área", portuguese: "Área" },
    Cancel: { english: "Cancel", spanish: "Cancelar", portuguese: "Cancelar" },
    Code: { english: "Code", spanish: "Código", portuguese: "Código" },
    Clear: {
        english: "Clear",
        spanish: "Limpiar",
        portuguese: "Limpar",
    },
    ClearSelections: {
        english: "Clear Selections",
        spanish: "Limpiar Selecciones",
        portuguese: "Limpar Seleções",
    },
    Client: { english: "Client", spanish: "Cliente", portuguese: "Cliente" },
    ClockIn: {
        english: "Clock In",
        spanish: "Registrar Entrada",
        portuguese: "Registrar Entrada",
    },
    ClockInRange: {
        english: "Clock In Range",
        spanish: "Rango de Entrada",
        portuguese: "Intervalo de Entrada",
    },
    ClockOut: {
        english: "Clock Out",
        spanish: "Registrar Salida",
        portuguese: "Registrar Saída",
    },
    Close: { english: "Close", spanish: "Cerrar", portuguese: "Fechar" },
    Confirm: {
        english: "Confirm",
        spanish: "Confirmar",
        portuguese: "Confirme",
    },
    ConfirmDelete: {
        english: "Are you sure you want to delete this?",
        spanish: "¿Estás seguro de que deseas eliminar esto?",
        portuguese: "Tem certeza de que deseja excluir isso?",
    },
    Customer: {
        english: "Customer",
        spanish: "Cliente",
        portuguese: "Cliente",
    },
    Customers: {
        english: "Customers",
        spanish: "Clientes",
        portuguese: "Clientes",
    },
    CustomerCode: {
        english: "Customer Code",
        spanish: "Código de Cliente",
        portuguese: "Código do Consumidor",
    },
    CustomerGroup: {
        english: "Customer Group",
        spanish: "Grupo de Clientes",
        portuguese: "Grupo de Clientes",
    },
    CustomerInfo: {
        english: "Customer Information",
        spanish: "Información del Cliente",
        portuguese: "Informações do Cliente",
    },
    CustomerList: {
        english: "Customer List",
        spanish: "Lista de Clientes",
        portuguese: "Lista de Clientes",
    },
    CustomerName: {
        english: "Customer Name",
        spanish: "Nombre del Cliente",
        portuguese: "Nome do Cliente",
    },
    Delete: { english: "Delete", spanish: "Borrar", portuguese: "Excluir" },
    DeleteLog: {
        english: "Delete Log",
        spanish: "Eliminar Registro",
        portuguese: "Excluir Registro",
    },
    Department: {
        english: "Department",
        spanish: "Departamento",
        portuguese: "Departamento",
    },
    Edit: { english: "Edit", spanish: "Editar", portuguese: "Editar" },
    EditCustomer: {
        english: "Edit Customer",
        spanish: "Editar Cliente",
        portuguese: "Editar Cliente",
    },
    EditFixture: {
        english: "Edit Fixture",
        spanish: "Editar Accesorio",
        portuguese: "Editar Aparelho",
    },
    EditLog: {
        english: "Edit Log",
        spanish: "Editar Registro",
        portuguese: "Editar Registro",
    },
    EditProject: {
        english: "Edit Project",
        spanish: "Editar Proyecto",
        portuguese: "Editar Projeto",
    },
    EditFixtures: {
        english: "Edit Fixtures",
        spanish: "Editar Accesorios",
        portuguese: "Editar Acessórios",
    },
    EditUser: {
        english: "Edit User",
        spanish: "Editar Usuario",
        portuguese: "Editar Usuário",
    },
    Employee: {
        english: "Employee",
        spanish: "Empleado",
        portuguese: "Funcionário",
    },
    Employees: {
        english: "Employees",
        spanish: "Empleados",
        portuguese: "Funcionário",
    },
    EmployeeInfo: {
        english: "Employee Information",
        spanish: "Información del Empleado",
        portuguese: "Informações do Funcionário",
    },
    EmployeeName: {
        english: "Employee Name",
        spanish: "Nombre de Empleado",
        portuguese: "Nome do Funcionário",
    },
    EmployeeWeeklyReport: {
        english: "Employee Weekly Report",
        spanish: "Informe Semanal del Empleado",
        portuguese: "Relatório Semanal do Funcionário",
    },
    EndDate: {
        english: "End Date",
        spanish: "Fecha Final",
        portuguese: "Data Final",
    },
    English: { english: "English", spanish: "Inglés", portuguese: "Inglês" },
    EnterGroupName: {
        english: "Enter group name",
        spanish: "Ingresar nombre del grupo",
        portuguese: "Inserir nome do grupo",
    },
    ErrorStartActivity: {
        english:
            "Error: Please Make Sure You Have Selected A Project, Fixture, And Process",
        spanish:
            "Error: Por favor, asegúrate de haber seleccionado un Proyecto, Accesorio, y Proceso",
        portuguese:
            "Erro: Por favor, certifique-se de ter selecionado um Projeto e Processo",
    },
    ExportToExcel: {
        english: "Export to Excel",
        spanish: "Exportar a Excel",
        portuguese: "Exportar para Excel",
    },
    ExportAll: {
        english: "Export All",
        spanish: "Exportar Todo",
        portuguese: "Exportar Tudo",
    },
    ExportSelected: {
        english: "Export Selected",
        spanish: "Exportar Seleccionado",
        portuguese: "Exportar Selecionado",
    },
    FirstName: {
        english: "First Name",
        spanish: "Primer Nombre",
        portuguese: "Primeiro Nome",
    },
    Fixture: {
        english: "Fixture",
        spanish: "Accesorio",
        portuguese: "Aparelho",
    },
    Fixtures: {
        english: "Fixtures",
        spanish: "Accesorios",
        portuguese: "Aparelhos",
    },
    FixtureCode: {
        english: "Fixture Code",
        spanish: "Código de Accesorio",
        portuguese: "Código do Aparelho",
    },
    FixtureInfo: {
        english: "Fixture Information",
        spanish: "Información del Accesorio",
        portuguese: "Informações do Aparelho",
    },
    FixtureName: {
        english: "Fixture Name",
        spanish: "Nombre del Accesorio",
        portuguese: "Nome do Aparelho",
    },
    FixtureNumber: {
        english: "Fixture Number",
        spanish: "Codigo de Accesorio",
        portuguese: "Número da Aparelho",
    },
    GroupName: {
        english: "Group Name",
        spanish: "Nombre del Grupo",
        portuguese: "Nome do Grupo",
    },
    GroupExists: {
        english: "Group already exists",
        spanish: "Grupo ya existe",
        portuguese: "Grupo já existe",
    },
    Hours: { english: "Hours", spanish: "Horas", portuguese: "Horas" },
    HourlyRate: {
        english: "Hourly Rate",
        spanish: "Salario por Hora",
        portuguese: "Salario",
    },
    HoursSpent: {
        english: "Hours Spent",
        spanish: "Horas Gastadas",
        portuguese: "Horas Gastas",
    },
    Inactive: {
        english: "Inactive",
        spanish: "Inactivo",
        portuguese: "Inativo",
    },
    ItemsPerPage: {
        english: "Items per page",
        spanish: "Elementos por página",
        portuguese: "Itens por página",
    },
    LaborReport: {
        english: "Labor Report",
        spanish: "Reporte de Mano de Obra",
        portuguese: "Relatório de Trabalho",
    },
    LastName: {
        english: "Last Name",
        spanish: "Apellido",
        portuguese: "Sobrenome",
    },
    Language: { english: "Language", spanish: "Idioma", portuguese: "Língua" },
    LogInfo: {
        english: "Log Information",
        spanish: "Información del Registro",
        portuguese: "Informação do Registro",
    },
    LogIn: {
        english: "Log In",
        spanish: "Iniciar Sesión",
        portuguese: "Entrar",
    },
    LogOut: {
        english: "Log Out",
        spanish: "Cerrar Sesión",
        portuguese: "Sair",
    },
    Month: {
        english: "Month",
        spanish: "Mes",
        portuguese: "Mês",
    },
    MonthlyReport: {
        english: "Monthly Report",
        spanish: "Informe Mensual",
        portuguese: "Relatório Mensal",
    },
    MultipleSelected: {
        english: "Multiple Selected",
        spanish: "Múltiples Seleccionados",
        portuguese: "Vários Selecionados",
    },
    MustBeTwoDigits: {
        english: "Must Be 2 Digits",
        spanish: "Debe tener 2 dígitos",
        portuguese: "Deve ter 2 dígitos",
    },
    MustBeFourDigits: {
        english: "Must Be 4 Digits",
        spanish: "Debe tener 4 dígitos",
        portuguese: "Deve ter 4 dígitos",
    },
    Name: { english: "Name", spanish: "Nombre", portuguese: "Nome" },
    NewGroup: {
        english: "New Group",
        spanish: "Nuevo Grupo",
        portuguese: "Novo Grupo",
    },
    NewPassword: {
        english: "Enter new password for",
        spanish: "Ingrese una nueva contraseña para",
        portuguese: "Digite uma nova senha para",
    },
    NightShift: {
        english: "Night Shift",
        spanish: "Turno da Noite",
        portuguese: "Turno Nocturno",
    },
    NoCustomerSelected: {
        english: "No Customer Selected",
        spanish: "Ningún Cliente Seleccionado",
        portuguese: "Nenhum Cliente Selecionado",
    },
    NoDataAvailable: {
        english: "No data available",
        spanish: "No hay datos disponibles",
        portuguese: "Não há dados disponíveis",
    },
    NoFixturesFound: {
        english: "No Fixtures Found",
        spanish: "No se Encontraron Accesorios",
        portuguese: "Nenhum Aparelho Encontrado",
    },
    Password: {
        english: "Password",
        spanish: "Contraseña",
        portuguese: "Senha",
    },
    Position: { english: "Position", spanish: "Puesto", portuguese: "Posição" },
    PositionInformation: {
        english: "Position Information",
        spanish: "Información de Posición",
        portuguese: "Informações de Posição",
    },
    Portuguese: {
        english: "Portuguese",
        spanish: "Portugués",
        portuguese: "Português",
    },
    Process: { english: "Process", spanish: "Proceso", portuguese: "Processo" },
    Processes: {
        english: "Process",
        spanish: "Procesos",
        portuguese: "Processos",
    },
    ProcessName: {
        english: "Process Name",
        spanish: "Nombre del Proceso",
        portuguese: "Nome do Processo",
    },
    ProcessReport: {
        english: "Process Report",
        spanish: "Informe de Proceso",
        portuguese: "Relatório de Processo",
    },
    Project: {
        english: "Project",
        spanish: "Proyecto",
        portuguese: "Projeto",
    },
    Projects: {
        english: "Projects",
        spanish: "Proyectos",
        portuguese: "Projetos",
    },
    ProjectCode: {
        english: "Project Code",
        spanish: "Código de proyecto",
        portuguese: "Código do projeto",
    },
    ProjectInfo: {
        english: "Project Information",
        spanish: "Información del Proyecto",
        portuguese: "Informações do Projeto",
    },
    ProjectName: {
        english: "Project Name",
        spanish: "Nombre del Proyecto",
        portuguese: "Nome do Projeto",
    },
    ProjectNumber: {
        english: "Project Number",
        spanish: "Número del Proyecto",
        portuguese: "Número do Projeto",
    },
    ProjectReport: {
        english: "Project Report",
        spanish: "Informe del Proyecto",
        portuguese: "Relatório do Projeto",
    },
    ProjectYear: {
        english: "Project Year",
        spanish: "Año del Proyecto",
        portuguese: "Ano do Projeto",
    },
    ProjectsRemoved: {
        english: "The following projects will be removed",
        spanish: "Los siguientes proyectos serán eliminados",
        portuguese: "Os seguintes projetos serão removidos",
    },
    PunchSystem: {
        english: "Punch System",
        spanish: "Sistema de Registro",
        portuguese: "Sistema de Registro",
    },
    PunchSystemLaborReport: {
        english: "Punch System Labor Report",
        spanish: "Informe de Trabajo del Sistema de Registro",
        portuguese: "Relatório de Trabalho do Sistema de Registro",
    },
    PunchSystemLogin: {
        english: "Punch System Log In",
        spanish: "Inicio de Sesión del Sistema de Registro",
        portuguese: "Login do Sistema de Registro",
    },
    RemovalConfirmation: {
        english: "Removal Confirmation",
        spanish: "Confirmación de Eliminación",
        portuguese: "Confirmação de Remoção",
    },
    RemovalConfirmationMsg: {
        english: "Are you sure you want to remove",
        spanish: "Estás seguro de que quieres eliminar",
        portuguese: "Você tem certeza que deseja remover",
    },
    RemoveProject: {
        english: "Remove Project",
        spanish: "Eliminar Proyecto",
        portuguese: "Remover Projeto",
    },
    RemoveUsers: {
        english: "Remove User",
        spanish: "Eliminar Usuario",
        portuguese: "Remover Usuário",
    },
    Reports: {
        english: "Reports",
        spanish: "Informes",
        portuguese: "Relatórios",
    },
    ResetPassword: {
        english: "Reset Password",
        spanish: "Restablecer la Contraseña",
        portuguese: "Redefinir a Senha",
    },
    ReturnToFixtures: {
        english: "Return to Fixtures",
        spanish: "Volver a Accesorios",
        portuguese: "Voltar para Aparelhos",
    },
    ReturnToHome: {
        english: "Return to Home",
        spanish: "Volver a Inicio",
        portuguese: "Voltar para a Página Inicial",
    },
    ReturnToProjects: {
        english: "Return to Projects",
        spanish: "Volver a Proyectos",
        portuguese: "Voltar para Projetos",
    },
    Required: {
        english: "Required",
        spanish: "Requerido",
        portuguese: "Obrigatório",
    },
    Status: {
        english: "Status",
        spanish: "Estado",
        portuguese: "Estado",
    },
    StartDate: {
        english: "Start Date",
        spanish: "Fecha Inicial",
        portuguese: "Data de início",
    },
    StartActivity: {
        english: "Start Activity",
        spanish: "Comenzar",
        portuguese: "Iniciar Atividade",
    },
    StopActivity: {
        english: "Stop Activity",
        spanish: "Detener",
        portuguese: "Parar Atividade",
    },
    Search: { english: "Search", spanish: "Buscar", portuguese: "Procurar" },
    SearchByFixtureNumber: {
        english: "Search by Fixture Number",
        spanish: "Buscar por Número de Accesorio",
        portuguese: "Procurar por Número de Aparelho",
    },
    SearchByFixtureName: {
        english: "Search by Fixture Name",
        spanish: "Buscar por Nombre de Accesorio",
        portuguese: "Procurar por Nome do Aparelho",
    },
    SearchByNumber: {
        english: "Search by Number",
        spanish: "Buscar por Número",
        portuguese: "Procurar por Número",
    },
    SelectActivityToStop: {
        english: "Select Only 1 Activity to Stop",
        spanish: "Selecciona Solo 1 Actividad para Detener",
        portuguese: "Selecione Apenas 1 Atividade para Parar",
    },
    SelectLog: {
        english: "Select a Labor Log",
        spanish: "Seleccionar un Registro de Trabajo",
        portuguese: "Selecionar um Registro de Trabalho",
    },
    SelectOneLog: {
        english: "Select Only 1 Labor Log",
        spanish: "Seleccionar Solo 1 Registro de Trabajo",
        portuguese: "Selecionar Apenas 1 Registro de Trabalho",
    },
    SelectProject: {
        english: "Select a Project",
        spanish: "Seleccionar un Proyecto",
        portuguese: "Selecionar um Projeto",
    },
    SelectOneProject: {
        english: "Select Only 1 Project",
        spanish: "Seleccionar Solo 1 Proyecto",
        portuguese: "Selecionar Apenas 1 Projeto",
    },
    SelectUser: {
        english: "Select a User",
        spanish: "Seleccionar un Usuario",
        portuguese: "Selecionar um Usuário",
    },
    SelectOneUser: {
        english: "Select Only 1 User",
        spanish: "Seleccionar Solo 1 Usuario",
        portuguese: "Selecionar Apenas 1 Usuário",
    },
    ShowReport: {
        english: "Show Report",
        spanish: "Mostrar Informe",
        portuguese: "Mostrar Relatório",
    },
    Spanish: { english: "Spanish", spanish: "Español", portuguese: "Espanhol" },
    Submit: { english: "Submit", spanish: "Enviar", portuguese: "Enviar" },
    TimeSpent: {
        english: "Time Spent",
        spanish: "Tiempo Invertido",
        portuguese: "Tempo Gasto",
    },
    Total: { english: "Total", spanish: "Total", portuguese: "Total" },
    TotalHours: {
        english: "Total hours",
        spanish: "Total de Horas",
        portuguese: "Total de horas",
    },
    TotalTime: {
        english: "Total Time",
        spanish: "Tiempo Total",
        portuguese: "Tempo Total",
    },
    Update: {
        english: "Update",
        spanish: "Actualizar",
        portuguese: "Atualizar",
    },
    UserID: {
        english: "User ID",
        spanish: "ID de Usuario",
        portuguese: "ID do Usuário",
    },
    Users: {
        english: "Users",
        spanish: "Usuários",
        portuguese: "Usuários",
    },
    UserPermissions: {
        english: "User permissions not set",
        spanish: "Permisos de usuario no establecidos",
        portuguese: "Permissões de usuário não definidas",
    },
    UserRemoved: {
        english: "The following user will be removed",
        spanish: "El siguiente usuario será eliminado",
        portuguese: "O seguinte usuário será removido",
    },
    View: {
        english: "View",
        spanish: "Ver",
        portuguese: "Ver",
    },
    Warning: {
        english: "Warning",
        spanish: "Advertencia",
        portuguese: "Aviso",
    },
    Week: { english: "Week", spanish: "Semana", portuguese: "Semana" },
    Welcome: {
        english: "Welcome",
        spanish: "Bienvenido",
        portuguese: "Bem-vindo",
    },
    Year: { english: "Year", spanish: "Año", portuguese: "Ano" },
    YouHaveFinishedTheFollowing: {
        english: "You Have Finished The Following",
        spanish: "Has Terminado lo Siguiente",
        portuguese: "Você Terminou o Seguinte",
    },
    YouHaveStartedTheFollowing: {
        english: "You Have Started The Following",
        spanish: "Usted ha comenzado el siguiente",
        portuguese: "Você começou o seguinte",
    },

    /////////////////////////// PAGE HEADERS ///////////////////////////
    ActiveJobsPage: {
        english: "PUNCH SYSTEM - ACTIVE JOBS",
        spanish: "SISTEMA DE REGISTRO - TRABAJOS ACTIVOS",
        portuguese: "SISTEMA DE REGISTRO - TRABALHOS ATIVOS",
    },
    EmployeesPage: {
        english: "PUNCH SYSTEM - EMPLOYEES",
        spanish: "SISTEMA DE REGISTRO - EMPLEADOS",
        portuguese: "SISTEMA DE REGISTRO - FUNCIONÁRIOS",
    },
    LaborLogsPage: {
        english: "LABOR LOGS",
        spanish: "REGISTRO DE TRABAJO",
        portuguese: "REGISTRO DE TRABALHO",
    },
    ProjectsPage: {
        english: "PUNCH SYSTEM - PROJECTS",
        spanish: "SISTEMA DE REGISTRO - PROYECTOS",
        portuguese: "SISTEMA DE REGISTRO - PROJETOS",
    },

    /////////////////////////// MONTHS ///////////////////////////
    Jan: { english: "Jan", spanish: "Ene", portuguese: "Jan" },
    Feb: { english: "Feb", spanish: "Feb", portuguese: "Fev" },
    Mar: { english: "Mar", spanish: "Mar", portuguese: "Mar" },
    Apr: { english: "Apr", spanish: "Abr", portuguese: "Abr" },
    May: { english: "May", spanish: "May", portuguese: "Mai" },
    Jun: { english: "Jun", spanish: "Jun", portuguese: "Jun" },
    Jul: { english: "Jul", spanish: "Jul", portuguese: "Jul" },
    Aug: { english: "Aug", spanish: "Ago", portuguese: "Ago" },
    Sep: { english: "Sep", spanish: "Sep", portuguese: "Set" },
    Oct: { english: "Oct", spanish: "Oct", portuguese: "Out" },
    Nov: { english: "Nov", spanish: "Nov", portuguese: "Nov" },
    Dec: { english: "Dec", spanish: "Dic", portuguese: "Dez" },

    /////////////////////////// RETURN MESSAGES ///////////////////////////
    AddNewCustomer: {
        english: "Customer added",
        spanish: "Cliente añadido",
        portuguese: "Cliente adicionado",
    },
    AddNewCustomerError: {
        english: "Error adding customer",
        spanish: "Error al añadir cliente",
        portuguese: "Erro ao adicionar cliente",
    },
    AddNewFixture: {
        english: "Fixture added",
        spanish: "Accesorio añadido",
        portuguese: "Aparelho adicionado",
    },
    AddNewFixtureError: {
        english: "Error adding fixture",
        spanish: "Error al añadir accesorio",
        portuguese: "Erro ao adicionar aparelho",
    },
    AddNewProject: {
        english: "Project added",
        spanish: "Proyecto añadido",
        portuguese: "Projeto adicionado",
    },
    AddNewProjectError: {
        english: "Error adding project",
        spanish: "Error al añadir proyecto",
        portuguese: "Erro ao adicionar projeto",
    },
    ChangeProjectStatus: {
        english: "Project status updated",
        spanish: "Estado del proyecto actualizado",
        portuguese: "Status do projeto atualizado",
    },
    ChangeProjectStatusError: {
        english: "Failed to update project status",
        spanish: "No se pudo actualizar el estado del proyecto",
        portuguese: "Falha ao atualizar o status do projeto",
    },
    ChangeUserStatus: {
        english: "User status updated",
        spanish: "Estado del usuario actualizado",
        portuguese: "Status do usuário atualizado",
    },
    ChangeUserStatusError: {
        english: "Failed to update user status",
        spanish: "No se pudo actualizar el estado del usuario",
        portuguese: "Falha ao atualizar o status do usuário",
    },
    CreateEmployee: {
        english: "Employee added",
        spanish: "Empleado añadido",
        portuguese: "Funcionário adicionado",
    },
    CreateEmployeeError: {
        english: "Error adding employee",
        spanish: "Error al añadir empleado",
        portuguese: "Erro ao adicionar funcionário",
    },
    CreatePosition: {
        english: "Position added",
        spanish: "Posición agregada",
        portuguese: "Posição adicionada",
    },
    CreatePositionError: {
        english: "Error adding position",
        spanish: "Error al agregar la posición",
        portuguese: "Erro ao adicionar posição",
    },
    CurrentlyPunchedIn: {
        english: "You are currently punched in on this job",
        spanish: "Actualmente estás registrado en este trabajo",
        portuguese: "Você está atualmente envolvido neste trabalho",
    },
    CustomerCodeExists: {
        english: "Customer code already exists",
        spanish: "El código de cliente ya existe",
        portuguese: "O código de cliente já existe",
    },
    DeleteFixture: {
        english: "Fixture deleted",
        spanish: "Accesorio eliminado",
        portuguese: "Aparelho deletado",
    },
    DeleteFixtureError: {
        english: "Error deleting fixture",
        spanish: "Error al eliminar accesorio",
        portuguese: "Erro ao deletar aparelho",
    },
    DeleteLaborLog: {
        english: "Log deleted",
        spanish: "Registro eliminado",
        portuguese: "Registro deletado",
    },
    DeleteLaborLogError: {
        english: "Error deleting log",
        spanish: "Error al eliminar el registro",
        portuguese: "Erro ao deletar o registro",
    },
    DepartmentCodeExists: {
        english: "Department code already exists",
        spanish: "El código de departamento ya existe",
        portuguese: "O código do departamento já existe",
    },
    EditEmployee: {
        english: "Employee updated",
        spanish: "Empleado actualizado",
        portuguese: "Funcionário atualizado",
    },
    EditEmployeeError: {
        english: "Error updating employee",
        spanish: "Error al actualizar empleado",
        portuguese: "Erro ao atualizar funcionário",
    },
    EditLogMsg: {
        english: "Log updated",
        spanish: "Registro actualizado",
        portuguese: "Registro atualizado",
    },
    EditLogError: {
        english: "Error updating log",
        spanish: "Error al actualizar el registro",
        portuguese: "Erro ao atualizar o registro",
    },
    FinishActivities: {
        english: "Activity stopped",
        spanish: "Actividad detenida",
        portuguese: "Atividade interrompida",
    },
    FinishActivitiesError: {
        english: "Error stopping activity",
        spanish: "Error al detener la actividad",
        portuguese: "Erro ao interromper a atividade",
    },
    InputActivities: {
        english: "Starting activity. Please Wait.",
        spanish: "Iniciando actividad. Por favor espere.",
        portuguese: "Iniciando atividade. Por favor, aguarde.",
    },
    InputActivitiesError: {
        english: "Error starting activity",
        spanish: "Error al iniciar la actividad",
        portuguese: "Erro ao iniciar a atividade",
    },
    InvalidLog: {
        english: "Invalid labor log",
        spanish: "Registro laboral inválido",
        portuguese: "Registro de trabalho inválido",
    },
    LogInMsg: {
        english: "Login Succesful",
        spanish: "Inicio de sesión exitoso",
        portuguese: "Login bem-sucedido",
    },
    LogInError: {
        english: "Invalid Credentials",
        spanish: "Credenciales inválidas",
        portuguese: "Credenciais inválidas",
    },
    LogOutMsg: {
        english: "Logout Succesful",
        spanish: "Cierre de sesión exitoso",
        portuguese: "Logout bem-sucedido",
    },
    MissingRequiredFields: {
        english: "Missing required fields",
        spanish: "Campos requeridos faltantes",
        portuguese: "Campos obrigatórios ausentes",
    },
    ResetUserPassword: {
        english: "User password reset",
        spanish: "Restablecimiento de contraseña de usuario",
        portuguese: "Redefinição de senha do usuário",
    },
    ResetUserPasswordError: {
        english: "Failed to reset user password",
        spanish: "No se pudo restablecer la contraseña del usuario",
        portuguese: "Falha ao redefinir a senha do usuário",
    },
    UpdateCustomer: {
        english: "Customer updated",
        spanish: "Cliente actualizado",
        portuguese: "Cliente atualizado",
    },
    UpdateCustomerError: {
        english: "Error updating customer",
        spanish: "Error al actualizar cliente",
        portuguese: "Erro ao atualizar cliente",
    },
    UpdateFixture: {
        english: "Fixture updated",
        spanish: "Accesorio actualizado",
        portuguese: "Aparelho atualizado",
    },
    UpdateFixtureError: {
        english: "Error updating fixture",
        spanish: "Error al actualizar accesorio",
        portuguese: "Erro ao atualizar aparelho",
    },
    UpdateProject: {
        english: "Project updated",
        spanish: "Proyecto actualizado",
        portuguese: "Projeto atualizado",
    },
    UpdateProjectError: {
        english: "Error updating project",
        spanish: "Error al actualizar el proyecto",
        portuguese: "Erro ao atualizar o projeto",
    },
    UserIdExists: {
        english: "User ID already exists",
        spanish: "El ID de usuario ya existe",
        portuguese: "O ID de usuário já existe",
    },
};

export function filterTranslations(userLanguage) {
    const validLanguages = ["english", "spanish", "portuguese"];
    const language = validLanguages.includes(userLanguage)
        ? userLanguage
        : "english";

    const filtered = {};

    for (const key in Translations) {
        if (Translations[key][language]) {
            filtered[key] = Translations[key][language];
        }
    }

    return filtered;
}
